//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

/*
This controller is meant to be used on older pages that don't have a root level angular component
and used lift snippets that could be replaced with angular directives like ng-if.

No new page should use this controller.
 */

(function() {
  const curalate = angular.module('curalate');

  curalate.controller('LiftBridgeController', ['SessionVarsService', function(SessionVarsService) {
    this.isFeatureEnabled = feature => SessionVarsService.isFeatureEnabled(feature);
    this.isSyndicationClient = () => SessionVarsService.isSyndicationClient();
  }]);
})();
